export const getProjectSelector = state => state.projects.project
export const getProjectIdSelector = state => state.projects.projectId
export const getProjectFetchStatus = state => state.projects.fetching
